import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'

import { useIdentity } from '~/shell/auth/useIdentity'

import { identifyAmplitudeUser } from '.'

/**
 * Identifies the user by Auth0 subject and marks internal traffic with `is_admin`.
 */
export const AmplitudeIdentityBridge = () => {
  const { user } = useAuth0()
  const { isAdmin, customerClaim } = useIdentity()

  useEffect(() => {
    // Gated on the subject: identifying before login would attach an unresolved session's `is_admin`
    // to an anonymous device. The claims land a moment after the subject does, so an identified session
    // is briefly attributed to the identity an unread token yields, then corrected by the next call.
    if (!user?.sub) {
      return
    }

    identifyAmplitudeUser(user.sub, {
      is_admin: isAdmin,
      customer: customerClaim ?? undefined,
    })
  }, [user?.sub, isAdmin, customerClaim])

  return null
}
